import { useCallback } from "react";

import { useTenant } from "@/contexts/tenant-provider";

import { clinicCalendarDay } from "@/lib/billing/membership-billing-start";

/**
 * Resolve a timestamp to the calendar day it names *in the clinic's timezone*.
 *
 * Some fields belong to the clinic rather than to whoever is looking. The
 * backend stamps `member.start_date` with `datetime.now(tenant_tz)` and acts on
 * `start_date.astimezone(tenant_tz).date()`, so that is the day to show — and
 * `getTimezone()` cannot supply it, because it returns the viewer's override or
 * their browser and never consults the tenant.
 *
 * Returns `YYYY-MM-DD`, so hand the result to `formatDate`, which pins a
 * calendar day and cannot shift it again.
 */
export function useClinicDay() {
  const { tenant } = useTenant();
  const timezone = tenant?.defaultTimezone;

  return useCallback(
    (value: string | Date | null | undefined): string =>
      value ? clinicCalendarDay(new Date(value), timezone) : "",
    [timezone],
  );
}
